export default "__VITE_ASSET__DPq0y8Mu__"